import { render, staticRenderFns } from "./TabsSelector.vue?vue&type=template&id=0d160e72&"
import script from "./TabsSelector.vue?vue&type=script&lang=js&"
export * from "./TabsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports